// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   TextField,
//   Typography,
//   IconButton,
//   Snackbar,
//   Alert,
//   Paper,
// } from '@mui/material';
// import { Visibility, VisibilityOff, Mail } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import Logo1 from '../../src/landpageimage/logo1.png';
// import Logo2 from '../../src/landpageimage/TDTLLogo.png';
// import Logo3 from '../../src/landpageimage/logo2.jpg';
// import Logo4 from '../landpageimage1/DYPLogo.png';

// const themeColors = {
//   primary: '#9333EA',
//   gradient: 'linear-gradient(90deg, transparent, rgb(238, 236, 240), transparent)',
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   width: '100%',
//   maxWidth: '600px',
//   margin: 'auto',
//   marginTop: '40px',
//   padding: '24px',
//   borderRadius: '16px',
//   boxShadow: '0 20px 40px rgba(147, 51, 234, 0.15)',
// }));

// const LogoContainer = styled(Box)(() => ({
//   display: 'flex',
//   justifyContent: 'center',
//   gap: '16px',
//   marginBottom: '24px',
// }));

// const LogoImage = styled('img')(() => ({
//   maxWidth: '80px',
//   maxHeight: '60px',
//   objectFit: 'contain',
// }));

// const StyledTextField = styled(TextField)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#F3F4F6',
//     '&:hover': {
//       backgroundColor: '#F9FAFB',
//     },
//     '&.Mui-focused': {
//       backgroundColor: '#F9FAFB',
//       '& fieldset': {
//         borderColor: themeColors.primary,
//         borderWidth: '2px',
//       },
//     },
//   },
//   '& .MuiInputLabel-root.Mui-focused': {
//     color: themeColors.primary,
//   },
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   backgroundColor: themeColors.primary,
//   color: 'white',
//   padding: '12px',
//   borderRadius: '12px',
//   textTransform: 'none',
//   fontSize: '16px',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: '#7E22CE',
//   },
// }));

// export default function ForgotPassword() {
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmNewPassword, setConfirmNewPassword] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [error, setError] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);

//   const navigate = useNavigate();

//   const handleSnackbarClose = () => setOpenSnackbar(false);

//   const handleSendOTP = async () => {
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/forgot_password/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email }),
//       });
//       if (response.ok) {
//         setOtpSent(true);
//         setError('');
//       } else {
//         setError('Failed to send OTP. Please try again.');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again later.');
//     }
//   };

//   const handleResetPassword = async () => {
//     if (newPassword !== confirmNewPassword) {
//       setError('Passwords do not match.');
//       return;
//     }
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/reset_password/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, otp, new_password: newPassword }),
//       });
//       if (response.ok) {
//         setSuccessMessage('Password reset successfully!');
//         setOpenSnackbar(true);
//         setOtpSent(false);
//         setEmail('');
//         setOtp('');
//         setNewPassword('');
//         setConfirmNewPassword('');
//         setTimeout(() => navigate('/Login@elephanttank'), 3000); // Navigate after 3 seconds
//       } else {
//         setError('Failed to reset password. Please try again.');
//       }
//     } catch (err) {
//       setError('An error occurred. Please try again later.');
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.gradient,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <LogoContainer>
//           <LogoImage src={Logo1} alt="Logo 1" />
//           <LogoImage src={Logo2} alt="Logo 2" />
//           <LogoImage src={Logo3} alt="Logo 3" />
//           <LogoImage src={Logo4} alt="Logo 4" />
//         </LogoContainer>
//         <Typography variant="h5" fontWeight="bold" align="center" mb={3}>
//           Reset Your Password
//         </Typography>
//         {error && (
//           <Typography color="error" variant="body2" mb={2}>
//             {error}
//           </Typography>
//         )}
//         {otpSent ? (
//           <>
//             <StyledTextField
//               fullWidth
//               label="OTP"
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//               sx={{ mb: 2 }}
//             />
//             <StyledTextField
//               fullWidth
//               label="New Password"
//               type={showPassword ? 'text' : 'password'}
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//               InputProps={{
//                 endAdornment: (
//                   <IconButton onClick={() => setShowPassword(!showPassword)}>
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 ),
//               }}
//               sx={{ mb: 2 }}
//             />
//             <StyledTextField
//               fullWidth
//               label="Confirm New Password"
//               type={showPassword ? 'text' : 'password'}
//               value={confirmNewPassword}
//               onChange={(e) => setConfirmNewPassword(e.target.value)}
//               sx={{ mb: 2 }}
//             />
//             <Box sx={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
//               <StyledButton fullWidth onClick={handleSendOTP}>
//                 Resend OTP
//               </StyledButton>
//               <StyledButton fullWidth onClick={handleResetPassword}>
//                 Reset Password
//               </StyledButton>
//             </Box>
//           </>
//         ) : (
//           <>
//             <StyledTextField
//               fullWidth
//               label="Email Address"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               InputProps={{
//                 startAdornment: (
//                   <Mail sx={{ color: themeColors.primary, mr: 1 }} />
//                 ),
//               }}
//               sx={{ mb: 2 }}
//             />
//             <StyledButton fullWidth onClick={handleSendOTP}>
//               Send OTP
//             </StyledButton>
//           </>
//         )}
//       </StyledPaper>

//       <Snackbar
//         open={openSnackbar}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
//           {successMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }
import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  IconButton,
  Snackbar,
  Alert,
  Paper,
} from '@mui/material';
import { Visibility, VisibilityOff, Mail } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // Import SweetAlert2
import Logo1 from '../../src/landpageimage/logo1.png';
import Logo2 from '../../src/landpageimage/TDTLLogo.png';
import Logo3 from '../../src/landpageimage/logo2.jpg';
import Logo4 from '../landpageimage1/DYPLogo.png';

const themeColors = {
  primary: '#9333EA',
  gradient: 'linear-gradient(90deg, transparent, rgb(238, 236, 240), transparent)',
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: '600px',
  margin: 'auto',
  marginTop: '40px',
  padding: '24px',
  borderRadius: '16px',
  boxShadow: '0 20px 40px rgba(147, 51, 234, 0.15)',
}));

const LogoContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  marginBottom: '24px',
}));

const LogoImage = styled('img')(() => ({
  maxWidth: '80px',
  maxHeight: '60px',
  objectFit: 'contain',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: '#F3F4F6',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
    '&.Mui-focused': {
      backgroundColor: '#F9FAFB',
      '& fieldset': {
        borderColor: themeColors.primary,
        borderWidth: '2px',
      },
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: themeColors.primary,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: themeColors.primary,
  color: 'white',
  padding: '12px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#7E22CE',
  },
}));

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const navigate = useNavigate();

  const handleSnackbarClose = () => setOpenSnackbar(false);

  const handleSendOTP = async () => {
    Swal.fire({
      title: 'Sending OTP...',
      text: 'Please wait while we send you the OTP.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch('https://newbackend.elephant-tank.com/api/forgot_password/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setOtpSent(true);
        setError('');
        Swal.close(); // Close the loader
      } else {
        setError('Failed to send OTP. Please try again.');
        Swal.close(); // Close the loader
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
      Swal.close(); // Close the loader
    }
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmNewPassword) {
      setError('Passwords do not match.');
      return;
    }

    Swal.fire({
      title: 'Resetting Password...',
      text: 'Please wait while we reset your password.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await fetch('https://newbackend.elephant-tank.com/api/reset_password/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp, new_password: newPassword }),
      });

      if (response.ok) {
        setSuccessMessage('Password reset successfully!');
        setOpenSnackbar(true);
        setOtpSent(false);
        setEmail('');
        setOtp('');
        setNewPassword('');
        setConfirmNewPassword('');
        setTimeout(() => navigate('/Login@elephanttank'), 3000); // Navigate after 3 seconds
        Swal.close(); // Close the loader
      } else {
        setError('Failed to reset password. Please try again.');
        Swal.close(); // Close the loader
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
      Swal.close(); // Close the loader
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: themeColors.gradient,
        padding: '16px',
      }}
    >
      <StyledPaper>
        <LogoContainer>
          <LogoImage src={Logo1} alt="Logo 1" />
          <LogoImage src={Logo2} alt="Logo 2" />
          <LogoImage src={Logo3} alt="Logo 3" />
          <LogoImage src={Logo4} alt="Logo 4" />
        </LogoContainer>
        <Typography variant="h5" fontWeight="bold" align="center" mb={3}>
          Reset Your Password
        </Typography>
        {error && (
          <Typography color="error" variant="body2" mb={2}>
            {error}
          </Typography>
        )}
        {otpSent ? (
          <>
            <StyledTextField
              fullWidth
              label="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              sx={{ mb: 2 }}
            />
            <StyledTextField
              fullWidth
              label="New Password"
              type={showPassword ? 'text' : 'password'}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                ),
              }}
              sx={{ mb: 2 }}
            />
            <StyledTextField
              fullWidth
              label="Confirm New Password"
              type={showPassword ? 'text' : 'password'}
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Box sx={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
              <StyledButton fullWidth onClick={handleSendOTP}>
                Resend OTP
              </StyledButton>
              <StyledButton fullWidth onClick={handleResetPassword}>
                Reset Password
              </StyledButton>
            </Box>
          </>
        ) : (
          <>
            <StyledTextField
              fullWidth
              label="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                startAdornment: (
                  <Mail sx={{ color: themeColors.primary, mr: 1 }} />
                ),
              }}
              sx={{ mb: 2 }}
            />
            <StyledButton fullWidth onClick={handleSendOTP}>
              Send OTP
            </StyledButton>
          </>
        )}
      </StyledPaper>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          {successMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
}
